import React, { useEffect, useRef, useState } from 'react';
import styles from './Input.module.scss';
import Label from '../forms/label/Label';
import { ChromePicker } from 'react-color';

const SAFE_DEFAULT = '#000000';

const isValidHex = (v) =>
  typeof v === 'string' && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v);

const ColorInput = ({
  label,
  required,
  name,
  width,
  errors,
  touched,
  type,
  disabled,
  placeholder,
  grey,
  style,
  inputStyleProp,
  textInputStyle,
  value,
  onChange,
  right,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const wrapperRef = useRef(null);

  const safeValue = isValidHex(value) ? value : SAFE_DEFAULT;

  useEffect(() => {
    const onDocMouseDown = (e) => {
      if (!showColorPicker) return;
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target)) setShowColorPicker(false);
    };

    document.addEventListener('mousedown', onDocMouseDown);
    return () => document.removeEventListener('mousedown', onDocMouseDown);
  }, [showColorPicker]);

  const inputStyle = {
    width,
    borderColor: errors && touched ? '#F3223C' : grey ? '#000' : '#000',
    ...inputStyleProp,
  };

  return (
    <div className={styles['textBox-container']} style={{ ...style }}>
      {label && <Label text={label} required={required} right />}

      <div
        ref={wrapperRef}
        className={`${styles['icon-input-container']} ${
          right ? styles.right : ''
        }`}
        style={{ ...inputStyle, position: 'relative' }}
      >
        <div
          style={{
            width: 22,
            height: 20,
            borderRadius: '50%',
            backgroundColor: safeValue,
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
          onClick={() => !disabled && setShowColorPicker((p) => !p)}
        />

        {showColorPicker && !disabled && (
          <div
            style={{
              position: 'absolute',
              zIndex: 9,
              top: '110%',
              insetInlineStart: 0,
            }}
          >
            <ChromePicker
              color={safeValue}
              onChange={(c) => onChange(name, c.hex)}
            />
          </div>
        )}

        <input
          type={type || 'text'}
          id={label}
          name={name}
          required={required}
          placeholder={placeholder}
          className={styles['text-input']}
          value={safeValue}
          readOnly
          disabled={disabled}
          style={textInputStyle}
        />
      </div>
    </div>
  );
};

export default ColorInput;
